module.exports = __webpack_public_path__ + "img/newInt-noData.fde5b2af.svg";